'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import AnchorPopoverBodyBranch from 'rich-text-lib/components/anchor/AnchorPopoverBodyBranch';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import TinyMcePopover from './TinyMcePopover';
import withPopoverModeState from './withPopoverModeState';
import { jsx as _jsx } from "react/jsx-runtime";
function AnchorEditPopover(props) {
  const {
    editor,
    target,
    anchorList,
    mode,
    onModeChange,
    onRemove,
    onUpdate,
    onAnchorRemove
  } = props;
  const handleUpdate = id => {
    onUpdate(target, id);
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  useEffect(() => {
    // Change to preview popover on target change
    if (mode === PopoverBodyMode.EDIT && !target) {
      onModeChange(PopoverBodyMode.PREVIEW);
    }
  }, [target, mode, onModeChange]);
  useEffect(() => {
    const handleTogglePopover = ({
      shouldOpen = true
    }) => {
      onModeChange(shouldOpen ? PopoverBodyMode.EDIT : PopoverBodyMode.PREVIEW);
    };
    editor.on('ToggleAnchorEditPopover', handleTogglePopover);
    return () => editor.off('ToggleAnchorEditPopover', handleTogglePopover);
  }, [editor, onModeChange]);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "anchor-edit-popover",
    editor: editor,
    target: target,
    open: !!target,
    placement: "bottom left",
    onRemove: onRemove,
    content: /*#__PURE__*/_jsx(AnchorPopoverBodyBranch, {
      mode: mode,
      anchorId: target && target.id,
      anchorList: anchorList,
      tooltipClassName: "mce-anchor-tooltip",
      onModeChange: onModeChange,
      onUpdate: handleUpdate,
      onAnchorRemove: onAnchorRemove.bind(null, target)
    })
  });
}
AnchorEditPopover.propTypes = {
  editor: PropTypes.object.isRequired,
  target: PropTypes.exact(HTMLAnchorElement),
  anchorList: PropTypes.array,
  mode: PropTypes.oneOf(Object.keys(PopoverBodyMode).map(key => PopoverBodyMode[key])),
  onRemove: PropTypes.func.isRequired,
  onModeChange: PropTypes.func,
  onAnchorRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
export default withPopoverModeState(AnchorEditPopover);